import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "V. Past Surgical History 過去の手術歴", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-darkgray-800" }, "Please indicate the date of your last visit to a hospital, clinic, or diagnostic center, including the reason, hospitalization status, and any findings or diagnoses. / 病院、クリニック、健診センターへの最近の受診日、受診理由、入院の有無、および診断結果(必要に応じて)を明記してください。", -1)
const _hoisted_4 = {
  key: 0,
  class: "col-span-full text-right"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-span-full lg:col-span-4" }
const _hoisted_7 = { class: "col-span-full lg:col-span-4" }
const _hoisted_8 = { class: "col-span-full lg:col-span-4" }

import TextInput from '@/components/inputs/TextInput.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PastSurgicalHistory',
  props: {
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
    errors: {
        type: Array,
        required: true
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)

const addRow = () => {
    item.value.push({
        date: null,
        purpose_of_visit: null,
        findings: null,
    })
}

const remove = (index: string) => {
    item.value.splice(index, 1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value, (surgery, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid grid-cols-1 lg:grid-cols-12 gap-x-8 gap-y-4 bg-primary-50 rounded-2xl p-5 lg:p-7 mb-2",
        key: index
      }, [
        (index >= 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (!__props.disableInputs)
                ? (_openBlock(), _createElementBlock("small", {
                    key: 0,
                    onClick: ($event: any) => (remove(index)),
                    class: "text-red-500 cursor-pointer text-sm"
                  }, "Remove", 8, _hoisted_5))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createBlock(CalendarPicker, {
            disabled: __props.disableInputs,
            key: surgery.date,
            modelValue: surgery.date,
            "onUpdate:modelValue": ($event: any) => ((surgery.date) = $event),
            id: `surgery-date-${index}`,
            inline: false,
            placeholder: "Date 日付",
            isTodayMaxDate: "",
            error: __props.errors[`past_surgical_history.${index}.date`] ? __props.errors[`past_surgical_history.${index}.date`][0] : ''
          }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "id", "error"]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            modelValue: surgery.purpose_of_visit,
            "onUpdate:modelValue": ($event: any) => ((surgery.purpose_of_visit) = $event),
            id: `purpose-${index}`,
            type: "text",
            placeholder: "Purpose of Visit 受診目的",
            disabled: __props.disableInputs,
            error: __props.errors[`past_surgical_history.${index}.purpose_of_visit`] ? __props.errors[`past_surgical_history.${index}.purpose_of_visit`][0] : ''
          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled", "error"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(TextInput, {
            modelValue: surgery.findings,
            "onUpdate:modelValue": ($event: any) => ((surgery.findings) = $event),
            id: `findings-${index}`,
            type: "text",
            placeholder: "Findings (if necessary) 診断結果(必要に応じて)",
            disabled: __props.disableInputs,
            error: __props.errors[`past_surgical_history.${index}.findings`] ? __props.errors[`past_surgical_history.${index}.findings`][0] : ''
          }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "disabled", "error"])
        ])
      ]))
    }), 128)),
    (!__props.disableInputs)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          onClick: addRow,
          class: "font-bold text-primary-500 hover:text-primary-700 transition cursor-pointer text-sm w-fit"
        }, " Add another + "))
      : _createCommentVNode("", true)
  ]))
}
}

})